const Faces = {
  top: {
    KubusEenBo: {
      piece: 'Elbow',
      angle: 270,
      track: 2,
    },
    KubusTweeBoonst: {
      piece: 'Elbow',
      angle: 180,
      track: 2,
    },
    KubusDrieBo: {
      piece: 'Gee',
      angle: 90,
      track: 2,
    },
    KubusVierBoonst: {
      piece: 'Bowl',
      angle: 270,
      track: 2,
    },
    KubusSeweBoonste: {
      piece: 'Line',
      track: 3,
    },
    KubusBoonste: {
      piece: 'Cap',
      angle: 180,
      track: 3,
    },
    KubusElfBo: {
      piece: 'Lanes',
      angle: 90,
      track: 2,
    },
    KubusTwaalfBo: {
      piece: 'Elbow',
      angle: 180,
      track: 2,
    },
    KubusDertienBo: {
      piece: 'Cap',
      track: 2,
    },
    KubusSestienBo: {
      piece: 'Elbow',
      angle: 90,
      track: 2,
    },
    KubusAgtienBo: {
      piece: 'Loop',
      angle: 90,
      track: 3,
    },
    KubusNegentienBo: {
      piece: 'Elbow',
      angle: 180,
      track: 3,
    },
    KubusTwintigBokant: {
      piece: 'Line',
      track: 1,
    },
    KubusVierEnTwintigBokant: {
      piece: 'Snake',
      track: 1,
    },
    KubusVyfEnTwintigBokant: {
      piece: 'Snake',
      angle: 90,
      track: 2,
    },
    KubusSesEnTwintigBokant: {
      piece: 'Elbow',
      angle: 90,
      track: 2,
    },
    KubusSeweEnTwintigBo: {
      piece: 'Drie',
      angle: 180,
      track: 0,
    },
  },
  right: {
    KubusTweeRegs: {
      piece: 'Split',
      track: 2,
    },
    KubusDrieRegs: {
      piece: 'Vier',
      track: 0,
    },
    KubusVyfRegs: {
      piece: 'Elbow',
      angle: 270,
      track: 1,
    },
    KubusSeweRegs: {
      piece: 'Cap',
      angle: 270,
      track: 1,
    },
    KubusAgtRegs: {
      piece: 'Elbow',
      angle: 90,
      track: 1,
    },
    KubusNegeRegs: {
      piece: 'Elbow',
      angle: 270,
      track: 2,
    },
    KubusTienReg: {
      piece: 'Split',
      angle: 90,
      track: 2,
    },
    KubusElfRegs: {
      piece: 'Fork',
      track: 2,
    },
    KubusDertienRegs: {
      piece: 'Elbow',
      angle: 180,
      track: 3,
    },
    KubusVeertienRegs: {
      piece: 'Elbow',
      angle: 270,
      track: 3,
    },
    KubusVyftienRegs: {
      piece: 'Snake',
      track: 3,
    },
    KubusSestienRegs: {
      piece: 'Elbow',
      angle: 90,
      track: 3,
    },
    KubusSewentienRegs: {
      piece: 'Elbow',
      angle: 270,
      track: 3,
    },
    KubusAgtienRegs: {
      piece: 'Line',
      track: 3,
    },
    KubusNegentienRegs: {
      piece: 'Elbow',
      track: 3,
    },
    KubusTwintigRegs: {
      piece: 'Cap',
      angle: 270,
      track: 2,
    },
    KubusTweeEnTwintigRegs: {
      piece: 'Line',
      track: 2,
    },
    KubusDrieEnTwintigRegs: {
      piece: 'Line',
      track: 2,
    },
    KubusVierEnTwintigRegs: {
      piece: 'Elbow',
      angle: 90,
      track: 2,
    },
    KubusSesEnTwintigRegs: {
      piece: 'Line',
      angle: 90,
      track: 1,
    },
    KubusSeweEnTwintigRegs: {
      piece: 'Snake',
      angle: 90,
      track: 2,
    },
  },
  left: {
    KubusDrieLinks: {
      piece: 'Elbow',
      angle: 90,
      track: 2,
    },
    KubusVierOor: {
      piece: 'Elbow',
      track: 1,
    },
    KubusSesOor: {
      piece: 'Elbow',
      angle: 270,
      track: 2,
    },
    KubusAgtOo: {
      piece: 'Elbow',
      angle: 90,
      track: 2,
    },
    KubusTienOor: {
      piece: 'Cap',
      angle: 270,
      track: 1,
    },
    KubusElfOor: {
      piece: 'Elbow',
      angle: 90,
      track: 1,
    },
    KubusTwaalfOor: {
      piece: 'Elbow',
      track: 3,
    },
    KubusVyftienOor: {
      piece: 'Line',
      angle: 90,
      track: 3,
    },
    KubusSestienOor: {
      piece: 'Elbow',
      angle: 90,
      track: 3,
    },
    KubusSewentienOor: {
      piece: 'Elbow',
      angle: 270,
      track: 3,
    },
    KubusAgtienOor: {
      piece: 'Cap',
      angle: 90,
      track: 3,
    },
    KubusNegentienOor: {
      piece: 'Agt',
      angle: 270,
      track: 0,
    },
    KubusEenEnTwintigOor: {
      piece: 'Elbow',
      angle: 270,
      track: 1,
    },
    KubusTweeEnTwintigOor: {
      piece: 'Fork',
      angle: 270,
      track: 1,
    },
    KubusDrieEnTwintigOor: {
      piece: 'Fork',
      angle: 90,
      track: 1,
    },
    KubusVierEnTwintigOor: {
      piece: 'Line',
      angle: 90,
      track: 1,
    },
    KubusVyfEnTwintigOor: {
      piece: 'Line',
      track: 1,
    },
    KubusSesEnTwintigOor: {
      piece: 'Snake',
      track: 1,
    },
    KubusSeweEnTwintigOor: {
      piece: 'Elbow',
      track: 2,
    },
  },
};

export default Faces;
